import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import AnalyticsCard from './AnalyticsCard';

const RADIAN = Math.PI / 180;
function PctLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }) {
  const r = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + r * Math.cos(-midAngle * RADIAN);
  const y = cy + r * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize={13} fontWeight={600}>
      {(percent * 100).toFixed(1)}%
    </text>
  );
}

export default function StatusDistribution({ data, kpis }) {
  return (
    <AnalyticsCard title="Claim Status Distribution">
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie data={data} dataKey="count" nameKey="status" cx="50%" cy="50%" outerRadius={80} labelLine={false} label={PctLabel}>
            {data.map((entry, i) => <Cell key={i} fill={entry.fill} />)}
          </Pie>
          <Tooltip formatter={(v) => v.toLocaleString()} />
          <Legend wrapperStyle={{ fontSize: 11 }} />
        </PieChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <div className="rounded-lg p-3 text-center" style={{ background: '#10b98118' }}>
          <p className="text-xl font-bold" style={{ color: '#10b981' }}>{kpis.completed.toLocaleString()}</p>
          <p className="text-xs font-medium mt-0.5 text-text-secondary">Completed</p>
        </div>
        <div className="rounded-lg p-3 text-center" style={{ background: '#ef444418' }}>
          <p className="text-xl font-bold" style={{ color: '#ef4444' }}>{kpis.failed.toLocaleString()}</p>
          <p className="text-xs font-medium mt-0.5 text-text-secondary">Failed</p>
        </div>
      </div>
    </AnalyticsCard>
  );
}
